import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams } from 'Models'
import {
	RbidosAccessAgentListModel,
	RbidosAgentCreateModel,
	RbidosPointsModel,
} from 'Pages/registry_business_access_neo'
import { Callback } from 'Src/types/utilTypes'

export type NewListAgents = {
	count: number
	next: number
	previous: number
	results: RbidosAccessAgentListModel[]
}

export type RbidosAgentState = {
	list_agent: NewListAgents
	all_list_agent: NewListAgents
	agent: RbidosAgentCreateModel | null
	new_agent: RbidosAgentCreateModel | null
	access_agents: NewListAgents
	points: RbidosPointsModel[]
	requestParamsListAgent: RequestParams
	requestParamsAccessAgent: RequestParams
	requestParamsAllListAgent: RequestParams
}

export const rbidosAgentInitialState: RbidosAgentState = {
	list_agent: null,
	all_list_agent: null,
	agent: null,
	new_agent: null,
	access_agents: null,
	points: [],
	requestParamsListAgent: new RequestParams(),
	requestParamsAccessAgent: new RequestParams(),
	requestParamsAllListAgent: new RequestParams(),
}

export namespace rbidosAgentNS {
	export type GetListAgent = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetRequestParamsListAgent = PayloadAction<RequestParams>
	export type SetRequestParamsAccessAgent = PayloadAction<RequestParams>
	export type SetRequestParamsAllListAgent = PayloadAction<RequestParams>
	export type GetAllListAgent = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetListAgent = PayloadAction<NewListAgents>
	export type SetListAgentResults = PayloadAction<RbidosAccessAgentListModel[]>
	export type SetAllAgentsResults = PayloadAction<RbidosAccessAgentListModel[]>
	export type SetAllListAgent = PayloadAction<NewListAgents>
	export type CreateOneAgent = PayloadAction<RbidosAgentCreateModel>
	export type GetOneAgent = PayloadAction<string>
	export type SetOneAgent = PayloadAction<RbidosAgentCreateModel>
	export type GetAccessAgent = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAccessAgent = PayloadAction<NewListAgents>
	export type UpdateOneAgent = PayloadAction<{
		id: string
		data: RbidosAgentCreateModel
	}>
	export type GetIdentificationPoints = PayloadAction
	export type SetIdentificationPoints = PayloadAction<RbidosPointsModel[]>
	export type SetNewAgent = PayloadAction<RbidosAgentCreateModel>
}

export const rbidosAgentSlice = createSlice({
	name: 'rbidosAgent',
	initialState: rbidosAgentInitialState,
	reducers: {
		getListAgent: (state, action: rbidosAgentNS.GetListAgent) => {},
		setRequestParamsListAgent: (state, action: rbidosAgentNS.SetRequestParamsListAgent) => {
			state.requestParamsListAgent = action.payload
		},
		setRequestParamsAccessAgent: (state, action: rbidosAgentNS.SetRequestParamsAccessAgent) => {
			state.requestParamsAccessAgent = action.payload
		},
		setRequestParamsAllListAgent: (state, action: rbidosAgentNS.SetRequestParamsAllListAgent) => {
			state.requestParamsAllListAgent = action.payload
		},
		clearListAgent: (state) => {
			state.list_agent = null
			state.requestParamsListAgent = new RequestParams()
		},
		clearAllListAgent: (state) => {
			state.all_list_agent = null
			state.requestParamsAllListAgent = new RequestParams()
		},
		clearAccessAgent: (state) => {
			state.access_agents = null
			state.requestParamsAccessAgent = new RequestParams()
		},
		setListAgent: (state, action: rbidosAgentNS.SetListAgent) => {
			state.list_agent = action.payload
		},
		setListAgentResults: (state, action: rbidosAgentNS.SetListAgentResults) => {
			state.list_agent.results = action.payload
		},
		getAllListAgent: (state, action: rbidosAgentNS.GetAllListAgent) => {},
		setAllListAgent: (state, action: rbidosAgentNS.SetAllListAgent) => {
			state.all_list_agent = action.payload
		},
		createOneAgent: (state, action: rbidosAgentNS.CreateOneAgent) => {},
		getOneAgent: (state, action: rbidosAgentNS.GetOneAgent) => {},
		setOneAgent: (state, action: rbidosAgentNS.SetOneAgent) => {
			state.agent = action.payload
		},
		getAccessAgent: (state, action: rbidosAgentNS.GetAccessAgent) => {},
		setAccessAgents: (state, action: rbidosAgentNS.SetAccessAgent) => {
			state.access_agents = action.payload
		},
		setAllAgentsResults: (state, action: rbidosAgentNS.SetAllAgentsResults) => {
			state.access_agents.results = action.payload
		},
		updateOneAgent: (state, action: rbidosAgentNS.UpdateOneAgent) => {},
		getIdentificationPoints: (state, action: rbidosAgentNS.GetIdentificationPoints) => {},
		setIdentificationPoints: (state, action: rbidosAgentNS.SetIdentificationPoints) => {
			state.points = action.payload
		},
		setNewAgent: (state, action: rbidosAgentNS.SetNewAgent) => {
			state.new_agent = action.payload
		},
	},
})
